var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMyorders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.007,
    height: 49,
    viewBox: "0 0 48.007 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment",
    transform: "translate(-0.006 0.529)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1215",
    "data-name": "Ellipse 1215",
    cx: 24,
    cy: 24.5,
    rx: 24,
    ry: 24.5,
    transform: "translate(0.006 -0.529)",
    fill: "#ffd400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15094",
    "data-name": "Path 15094",
    d: "M168.166,85.186c0-.967-9.745-13.041-12.749-15.681L146,71.365h-3.932L135,68.082l-2.382,34.36,5.215,6.519a24.167,24.167,0,0,0,30.329-23.776Z",
    transform: "translate(-120.153 -61.373)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15045",
    "data-name": "Path 15045",
    d: "M130.608,71.378l2.4-2.733,2.4,2.733,2.4-2.733,2.4,2.733,2.4-2.733,2.4,2.733,2.4-2.733,2.4,2.733,2.4-2.733,2.4,2.733v33.071l-2.4-2.733-2.4,2.733-2.4-2.733-2.4,2.733-2.4-2.733-2.4,2.733-2.4-2.733-2.4,2.733-2.4-2.733-2.4,2.733Z",
    transform: "translate(-118.579 -62.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15046",
    "data-name": "Path 15046",
    d: "M256.013,101.716l2.4,2.733,2.4-2.733,2.4,2.733,2.4-2.733,2.4,2.733V71.378l-2.4-2.733-2.4,2.733-2.4-2.733-2.4,2.733-2.4-2.733Z",
    transform: "translate(-232.001 -62.537)",
    fill: "#f2f6fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1755",
    "data-name": "Rectangle 1755",
    width: 17.9,
    height: 2.548,
    transform: "translate(15.06 12.767)",
    fill: "#cdd2e1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1756",
    "data-name": "Rectangle 1756",
    width: 8.948,
    height: 2.548,
    transform: "translate(24.011 12.767)",
    fill: "#bec3d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1757",
    "data-name": "Rectangle 1757",
    width: 17.9,
    height: 2.548,
    transform: "translate(15.06 17.481)",
    fill: "#cdd2e1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1758",
    "data-name": "Rectangle 1758",
    width: 17.9,
    height: 2.548,
    transform: "translate(15.06 22.196)",
    fill: "#cdd2e1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1759",
    "data-name": "Rectangle 1759",
    width: 17.9,
    height: 2.548,
    transform: "translate(15.06 26.91)",
    fill: "#cdd2e1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1760",
    "data-name": "Rectangle 1760",
    width: 8.95,
    height: 2.548,
    transform: "translate(24.01 17.481)",
    fill: "#bec3d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1761",
    "data-name": "Rectangle 1761",
    width: 8.95,
    height: 2.548,
    transform: "translate(24.01 22.196)",
    fill: "#bec3d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1762",
    "data-name": "Rectangle 1762",
    width: 8.95,
    height: 2.548,
    transform: "translate(24.01 26.91)",
    fill: "#bec3d2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyorders);
export default __webpack_public_path__ + "static/media/icon-myorders.9ae7ab55.svg";
export { ForwardRef as ReactComponent };